import { bankActionSelectors as selector } from "../Selectors/index";

export const BankReducer = (state = [], { type, payload }) => {
  switch (type) {
    case selector.GET_BANK:
      return payload;

    default:
      return state;
  }
};
